import _objectSpread from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { translateObject, translateObjectInverse } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { userMap } from '../translationMaps';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var goldenHugggFieldMap = {
  productId: 'product_id',
  remaining: 'remaining',
  sent: 'sent',
  expiry: 'expiry'
};
function formatUserResponseData(data) {
  var user = data.user,
    golden_hugggs = data.golden_hugggs,
    team = data.team;
  var formatted = {
    user: translateObject(userMap, user),
    team: team
  };
  if (golden_hugggs) {
    formatted.goldenHugggs = translateObjectInverse(goldenHugggFieldMap, golden_hugggs);
  }
  return formatted;
}

/**
 * Get the current logged in user.
 * Note: This endpoint returns the user golden hugggs information.
 *
 * @param {Object} axios Custom instance of axios
 */
function fetch(axios) {
  return axios.get(urls.apiV2('/auth/me')).then(prop('data')).then(formatUserResponseData);
}
function update(axios, data) {
  var formatted = translateObjectInverse(_objectSpread(_objectSpread({}, userMap), {}, {
    password: 'password'
  }), data);
  return axios.post(urls.apiV2('/users/update'), formatted).then(prop('data')).then(formatUserResponseData);
}

/**
 * Registers a new b2b user
 *
 * @param {Object} axios Custom instance of axios
 */
function b2bRegister(axios, data) {
  var formatted = translateObjectInverse(_objectSpread(_objectSpread({}, userMap), {}, {
    userId: 'userId',
    password: 'password',
    planId: 'planId',
    paymentMethod: 'paymentMethod',
    cardId: 'cardId',
    verificationToken: 'verificationToken'
  }), data);
  return axios.post(urls.apiV2('/users/b2b'), formatted).then(prop('data')).then(formatUserResponseData);
}

/**
 * Upgrades an existing b2b user
 *
 * @param {Object} axios Custom instance of axios
 */
function b2bUpgrade(axios, data) {
  var formatted = translateObjectInverse({
    planId: 'planId',
    paymentMethod: 'paymentMethod',
    cardId: 'cardId',
    verificationToken: 'verificationToken'
  }, data);
  return axios.post(urls.apiV2('/users/b2b/upgrade'), formatted).then(prop('data')).then(formatUserResponseData);
}

/**
 * Request a reset of a b2b user's password
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} data.username The username of the user to generate a reset
 */
function requestPasswordReset(axios, data) {
  var formatted = translateObjectInverse(userMap, data);
  return axios.post(urls.apiV2('/users/password/reset-request'), formatted);
}

/**
 * Resets a b2b user's password
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} data.token The password reset token
 * @param {String} data.password The new password
 */
function resetPassword(axios, data) {
  var formatted = translateObjectInverse({
    token: 'token',
    password: 'password'
  }, data);
  return axios.post(urls.apiV2('/users/password/reset'), formatted);
}

/**
 * Requests verification for a user
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} data.fullName The user's full name
 * @param {String} data.emailAddress The user's email address
 * @param {String} data.companyName The company name
 * @param {String} data.password The user's password
 * @param {String} data.userId The user's ID
 */
function requestVerification(axios, data) {
  return axios.post(urls.apiV2('/users/verification/request'), data).then(prop('data'));
}

/**
 * Verifies a user
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} data.verificationToken The verification token obtained from the requestVerification method
 */
function verify(axios, data) {
  return axios.post(urls.apiV2('/users/verification/verify'), data).then(prop('data'));
}

/**
 * Preregisters a user
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} data.email The email
 */
function preRegister(axios, data) {
  return axios.post(urls.apiV2('/users/presignup'), data);
}

/**
 * Resend an invite
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} inviteId The id of the existing invite
 */
function resendTeamInvite(axios, inviteId) {
  return axios.post(urls.apiV2("/teams/invites/".concat(inviteId, "/resend")));
}

/**
 * Request an invitation to a team.
 *
 * @param {Object} axios Custom instance of axios
 * @param {String} teamId The id of the team wanting to join
 * @param {String} email The email of the person wanting an invitation
 */
function requestTeamInvitation(axios, teamId, email) {
  return axios.post(urls.apiV2("/teams/".concat(teamId, "/invites/requests")), {
    email: email
  });
}
export default {
  fetch: withAxios(fetch),
  update: withAxios(update),
  b2bRegister: withAxios(b2bRegister, {
    useBackoff: false
  }),
  b2bUpgrade: withAxios(b2bUpgrade, {
    useBackoff: false
  }),
  preRegister: withAxios(preRegister),
  requestPasswordReset: withAxios(requestPasswordReset),
  requestVerification: withAxios(requestVerification),
  resetPassword: withAxios(resetPassword),
  verify: withAxios(verify),
  resendTeamInvite: withAxios(resendTeamInvite),
  requestTeamInvitation: withAxios(requestTeamInvitation)
};